import React from "react";

const Renew = () => {
  return (
    <React.Fragment>
      <img src="/static/renew/renew.png" alt="" />
    </React.Fragment>
  );
};

export default Renew;
